import React from "react";
import styled from "styled-components";
import {ReactTerminal} from "react-terminal";
import {SITE} from "site";
import {askNick} from "content/ask";
import {answerQuestion, PROCESS_SUMMARY} from "content/facts";

interface IProps {
    openApps: any;
    setOpenApps: any;
}

export default function Shell(props: IProps) {
    const {openApps, setOpenApps} = props;

    const help = (
        <span>
          <strong>Commands:</strong>
          <br/>
          <div style={{marginLeft: "2em"}}>
            <strong>ask [question]</strong> - Ask about Nick from public facts.
            <br/>
            <strong>process</strong> - How work ships (no source).
            <br/>
            <strong>help(module)</strong> - Get more information on a selected
            module.
            <br/>
            <strong>clear</strong> - Clears the console. <br/>
            <strong>easymode</strong> - Switches to easy mode. <br/>
            <strong>ls</strong> - lists files in current directory. <br/>
            <strong>./[[file]]</strong> - Runs a specific file. <br/>
            <strong>echo</strong> - Repeats what you type. <br/>
            <strong>domath</strong> - Does math for you. <br/>
          </div>

          <br/>
          <strong>Modules:</strong>
          <br/>
          <div style={{marginLeft: "2em"}}>
              <strong>nick</strong>
              <br/>
              <strong>diffex</strong>
              <br/>
              <strong>firstrobotics</strong>
          </div>
          <br/>
          <strong>For my bio please type `nick.bio` or `ask who are you`</strong> <br/>
          <strong>For my info on other modules type '[[module]].info'</strong>
        </span>
    );

    const moduleNickHelp = (
        <span>
          <strong>Variables:</strong>
          <br/>
          <div style={{marginLeft: "2em"}}>
            <strong>bio</strong> - Get to know more about me.
            <br/>
          </div>
        </span>
    );

    const moduleDiffexHelp = (
        <span>
          <strong>Variables:</strong>
          <br/>
          <div style={{marginLeft: "2em"}}>
            <strong>info</strong> - Get to know more about diffex.
            <br/>
          </div>
        </span>
    );

    const moduleFirstRoboticsHelp = (
        <span>
          <strong>Variables:</strong>
          <br/>
          <div style={{marginLeft: "2em"}}>
            <strong>info</strong> - Get to know more about my participation in First.
            <br/>
          </div>
        </span>
    );

    const diffexInfo = (
        <span>
          DiffEx is a web app that allows users to trade options on the Ethereum
          blockchain. The app is built using React, Redux, and Solidity.
        </span>
    );

    const firstRoboticsInfo = (
        <span>
          I mentor a local First Robotics team, The Grasshoppers, #95. I help teach
          students how to build robots and compete in competitions.
        </span>
    );

    const bio = (
        <span>
          Hello, my name is Nick.<br/>
          <ul>
            <li>
              <strong>Where do I live?</strong>
              <br/>
              Greater Boston Area
            </li>
            <li>
              <strong>Where did I go to school?</strong>
              <br/>
              Rensselaer Polytechnic Institute
            </li>
            <li>
              <strong>What did I major in?</strong>
              <br/>
              Computer science
            </li>
            <li>
              <strong>What do I do?</strong>
              <br/>
              Founder, Splitrock Consulting.
            </li>
            <li>
              <strong>How can you contact me?</strong>
              <br/>
              {SITE.email}
            </li>
          </ul>
        </span>
    );

    const commands = {
        "nick.bio": bio,
        "nick": bio,
        "diffex.info": diffexInfo,
        "diffex": diffexInfo,
        "firstrobotics.info": firstRoboticsInfo,
        "firstrobotics": firstRoboticsInfo,

        "help(nick)": moduleNickHelp,
        "help(diffex)": moduleDiffexHelp,
        "help(firstrobotics)": moduleFirstRoboticsHelp,

        ls: () => {
            return (
                <span>
                    diffex
                </span>
            );
        },

        "easymode": () => {
            window.location.href = "/bio";
        },

        "./diffex": () => {
            setOpenApps([...openApps, {
                id: "diffex",
                title: "DiffEx",
                x: 0,
                y: 0,
                width: 600,
                height: 600,
                url: SITE.diffex
            }]);
        },
        calculator: () => {
            setOpenApps([...openApps, {
                id: "calculator",
                title: "Calculator",
                x: 0,
                y: 0,
                width: 600,
                height: 600,
                url: "https://www.online-calculator.com/full-screen-calculator/"
            }]);
        },

        whoami: "Im not sure, who are you? To figure out more about me try: whoareyou.",
        whoareyou: () => answerQuestion("who are you"),
        echo: (text: string) => {
            return <span>{text}</span>;
        },
        help: help,
        "?": help,
        ask: async (question: string) => {
            const result = await askNick(question || "");
            return result.answer;
        },
        process: () => PROCESS_SUMMARY,
        domath: async (expr: string) => {
            const response = await fetch(
                `https://api.mathjs.org/v4/?expr=${encodeURIComponent(expr)}`
            );
            return await response.text();
        },
    };

    return (
        <Container>
            <ReactTerminal
                showControlBar={false}
                commands={commands}
                themes={{
                    splitrock: {
                        themeBGColor: "#272B36",
                        themeToolbarColor: "#DBDBDB",
                        themeColor: "#FFFEFC",
                        themePromptColor: "red",
                    },
                }}
                theme={"material-dark"}
                welcomeMessage={
                    <span
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        Welcome to splitrock.dev. Try `ask what do you do` or
                        `help`. <br/>
                    </span>
                }
                errorMessage={`I don't know that one, try using 'help' or '?'`}
                editorStyle={{fontSize: "clamp(10px, 2vw, 16px)"}}
            />
        </Container>
    );
}

const Container = styled.div`
  height: 500px;
  
  max-width: 1000px;
  max-height: 600px;
  background: #3c3c3c;

  border-radius: 10px;
`;
